(function(algolia) {
  'use strict';
  algolia.translations = {
    ...algolia.shopify.market.translations,
    // Add additinonal translations here
    search: 'Current search',
    noCollectionFound: 'No collection found',
    allProducts: 'See all products matching',
    noallProducts: 'See all products',
    matching: 'matching',
    sortBy: 'Sorted by',
    relevance: 'Sort',
    outOf: 'out of',
    resultsFound: 'results',
    oneResultFound: '1 result',
    noResultFound: 'No result',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear all',
    noPageFound: 'No page found',
    outOfStock: 'Out of stock',
    suggestions: 'Suggestion',
    noSuggestionFound: 'No suggestion found',
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return `${algolia.translations.noResultFor} " ${text} ".`;
    },
    in: function(processingTimeMS) {
      return `${algolia.translations.in} ${processingTimeMS / 1000}s`;
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },
    
    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ` ${ algolia.translations.outOf}`
      );
    },

    by: function(text) {
      if (!text) return '';
      return ` ${algolia.translations.by} ` + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
